import { proxy } from "valtio";
import {Engagement} from "@models/engagement.model.ts";
import { Launch } from "@models/launch.model";
import { AudienceDefinition } from "@models/audienceDefinition.model";
import type { EngagementNetworkViewResponse } from "@services/engagements/commands/cmdGetNetworkView";


export const engagementStore = proxy<{
    selectedEngagement: Engagement;
    selectedLaunch: Launch;
    selectedAudience: AudienceDefinition;
    listSearchParams: string;
    networkViewCache: EngagementNetworkViewResponse | null;
    networkViewCacheDate: Date | null;
}>({
    selectedEngagement: new Engagement(),
    selectedLaunch: new Launch(),
    selectedAudience: new AudienceDefinition,
    listSearchParams: "",
    networkViewCache: null,
    networkViewCacheDate: null,
});

